/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query SmsCountDlrQuery($customerId: ID, $vendorId: ID, $endDate: DateTime!, $startDate: DateTime!) {
    SmsCountDlr(customerId: $customerId, vendorId: $vendorId, endDate: $endDate, startDate: $startDate) {
      count,
      _totalCount,
      status,
      message
    }
  }
`


/*
 * EXPORTS
 */
export default Index
